import { render, staticRenderFns } from "./clientUserDetails.vue?vue&type=template&id=371b631c&scoped=true&"
import script from "./clientUserDetails.vue?vue&type=script&lang=js&"
export * from "./clientUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./clientUserDetails.vue?vue&type=style&index=0&id=371b631c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b631c",
  null
  
)

export default component.exports